import { createSlice } from '@reduxjs/toolkit';
import { setAutoFreeze } from 'immer';
setAutoFreeze(false); // 禁止凍結

const localModifyTourExtra = JSON.parse(
  sessionStorage.getItem('custom-itinerary-modifyTourExtra'),
);

const initialState = {
  // 已存入行程的資料
  stayDetailsData: localModifyTourExtra?.stayDetailsData || {},
  placeDetailsData: localModifyTourExtra?.placeDetailsData || {},

  // 查詢結果的資料
  staySearchDetailsData: localModifyTourExtra?.staySearchDetailsData || [],
  placeSearchDetailsData: localModifyTourExtra?.placeSearchDetailsData || [],

  // 預設資料
  stayOtherData: localModifyTourExtra?.stayOtherData || [],
  placeOtherData: localModifyTourExtra?.placeOtherData || [],

  // 預設token
  stayOtherToken: localModifyTourExtra?.stayOtherToken || '',
  placeOtherToken: localModifyTourExtra?.placeOtherToken || '',

  // 查詢結果中被選取的目標
  stayPick: localModifyTourExtra?.stayPick || '',
  placePick: localModifyTourExtra?.placePick || '',
};

export const modifyTourExtraSlice = createSlice({
  name: 'modifyTourExtra',
  initialState,
  reducers: {
    modifyTourExtraUpdate: (state, action) => {
      const newState = {
        ...state,
        ...action.payload,
      };

      sessionStorage.setItem(
        'custom-itinerary-modifyTourExtra',
        JSON.stringify(newState),
      );

      return newState;
    },
    modifyTourExtraReset: () => {
      sessionStorage.removeItem('custom-itinerary-modifyTourExtra');
      return {
        stayDetailsData: {},
        placeDetailsData: {},
        staySearchDetailsData: [],
        placeSearchDetailsData: [],
        stayOtherToken: '',
        placeOtherToken: '',
        stayPick: '',
        placePick: '',
      };
    },
  },
});

/** 調整行程2.0 - 擴充 */
export const modifyTourExtraSelect = (state) => state.modifyTourExtra;
export const { modifyTourExtraUpdate, modifyTourExtraReset } =
  modifyTourExtraSlice.actions;
export default modifyTourExtraSlice.reducer;
